import Svg, { Circle, Path, Defs, LinearGradient, Stop } from "react-native-svg";

interface AiIconSmProps {
  size?: number;
}

export function AiIconSm({ size = 32 }: AiIconSmProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      {/* @ts-expect-error baseline 2026-02-26 - react-native-svg Defs children typing incomplete with React 19 types */}
      <Defs>
        <LinearGradient id="aiIconSmGradient" x1="0" y1="0.951" x2="37.36" y2="22.85" gradientUnits="userSpaceOnUse">
          <Stop stopColor="#12C9FD" />
          <Stop offset="0.445451" stopColor="#2431A0" />
          <Stop offset="0.994505" stopColor="#F23D6F" />
        </LinearGradient>
      </Defs>
      <Circle cx="16" cy="16" r="16" fill="url(#aiIconSmGradient)" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9121 16.1507L14.1636 12.3963H14.9316L16.1831 16.1507L19.9375 17.4022V18.1702L16.1831 19.4217L14.9316 23.1761H14.1636L12.9121 19.4217L9.15771 18.1702V17.4022L12.9121 16.1507Z"
        fill="white"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9955 11.0912L20.6398 9.1582H21.4078L22.0521 11.0912L23.9851 11.7355V12.5035L22.0521 13.1479L21.4078 15.0809H20.6398L19.9955 13.1479L18.0625 12.5035V11.7355L19.9955 11.0912Z"
        fill="white"
      />
    </Svg>
  );
}
